import { geolocationRange } from '@/constants/index';

export function isValidCoordinate(
  longitude: number,
  latitude: number
): boolean {
  if (
    longitude > geolocationRange.MIN_LONGITUDE &&
    longitude < geolocationRange.MAX_LONGITUDE &&
    latitude > geolocationRange.MIN_LATITUDE &&
    latitude < geolocationRange.MAX_LATITUDE
  ) {
    return true;
  }

  return false;
}
